import React, {
  useState,
  createContext,
  useContext,
} from 'react';
import { ApplicationContextType } from './ApplicationContext.types';
import { ApplicationProviderProps } from './ApplicationProvider.types';
import { ApplicationStepType } from './ApplicationStep.types';

const ApplicationContext = createContext<ApplicationContextType>(undefined!);

export function useApplication() {
  return useContext(ApplicationContext);
}

export function ApplicationProvider({
  children,
}: ApplicationProviderProps) {
  const [activeStep, setActiveStep] = useState(0);
  const [steps, setSteps] = useState<ApplicationStepType[]>();

  const handleNext = () => { setActiveStep((prevActiveStep) => prevActiveStep + 1); };
  const handleBack = () => { setActiveStep((prevActiveStep) => prevActiveStep - 1); };

  return (
    <ApplicationContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        activeStep,
        steps,
        handleBack,
        handleNext,
        setSteps,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
}
